export const ERR_USER_NOT_FOUND = "USER_NOT_FOUND"
export const ERR_AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED"
export const ERR_BAD_REQUEST = "BAD_REQUEST"
export const ERR_VERIFICATION_CODE_ERROR = "VERIFICATION_CODE_ERROR"
export const ERR_UNAUTHORIZED = "UNAUTHORIZED"
export const ERR_HUB_SIGN_IN_FAILURE = "HUB_SIGN_IN_FAILURE"
